import { render, staticRenderFns } from "./SalesOrderEdit.vue?vue&type=template&id=65d66c8e&"
var script = {}
import style0 from "./SalesOrderEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports